module.exports = __webpack_public_path__ + "img/m5.684a3753.png";